import { defineStore } from 'pinia';
import Helper from '@/helpers/helper';
import ErrorHelper from '../helpers/errorManagerhelaper';
import Swal from 'sweetalert2';
import merge from 'lodash/merge';


export const useUserStore = defineStore('users', {
    state: () => {
        return {
            list: undefined,
            details: [],
            info: undefined,
            user: {}
        }
    },
    actions: {

        setUser(user) {
            this.user = user;
        },

        setInfo(item){
            this.info = item;
        },

        updateInfo(item) {
            this.info = merge({}, this.info, item);
        },

        getOne(id){
            this.list ??= [];
            const index = this.list.findIndex(t => t.id === id)
            if (index !== -1) {
               return this.list[index];
            }
            return null;
        },

        getOneDetails(id){
            this.list ??= [];
            const index = this.details.findIndex(t => t.id === id)
            if (index !== -1) {
               return this.details[index];
            }
            return null;
        },

        addDetail(item){
            this.details ??= [];
            const index = this.details.findIndex(t => t.id === item.id)
            if (index !== -1) {
                this.details[index] = merge({}, this.details[index], item);
            } else {
                this.details.unshift(item)
            }
              return item;
        },

        setData(list) {
            this.list = list;
        },

        addOne(newOne) {
            this.list ??= [];
            this.list.unshift(newOne)
        },

        updateOne(updated) {
            this.list ??= [];
            const index = this.list.findIndex(t => t.id === updated.id)
            if (index !== -1) {
                this.list[index] = merge({}, this.list[index], updated);
            }else {
                this.list.push(updated);
              }
        },

        
         removeOne(deleted) {
            this.list ??= [];
            this.list = this.list.filter(t => t.id != deleted.id) 
        },

     async  loadFromApi(londing = false) {
        try {
            if(londing){
                Swal.showLoading();
            }
            const route = 'users';
            const response = await fetch(Helper.route(route), Helper.requestOptionsJSON())

            if (!response.ok) {
                const error = await ErrorHelper.handleApiError(response);
                ErrorHelper.showError(error);
                return;
            }
            if(londing){
                Swal.close();
            }
            const data = await response.json()
            this.list = data
            return data;
        } catch (error) {
            const normalizedError = ErrorHelper.handleUnexpectedError(error);
            ErrorHelper.showError(normalizedError);
            throw normalizedError;
        }
    },

     async  loadOne(id, loading=false) {
        try {
            if(loading){
                Swal.showLoading(null);
            }
            

            const route = "users/" + id + "/details";
            const response = await fetch(Helper.route(route), Helper.requestOptionsJSON())

            if (!response.ok) {
                const error = await ErrorHelper.handleApiError(response);
                ErrorHelper.showError(error);
                return;
            }

            const resp = response.json();
            this.updateOne(resp);
            this.addDetail(resp);
            this.info = resp;

            if(loading){
                Swal.fire("User !", "Status successfully modified", "success");
            }

            return resp;

        } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
        }
    },

   



    async  toggleStatus(user_id) {
        try {
            Swal.showLoading(null);
            let body = { role: "manager", status: "active" };

            const route = "users/" + user_id + "/status/toggle";
            const response = await fetch(Helper.route(route), Helper.requestOptionsJSON("PUT", body))

            if (!response.ok) {
                const error = await ErrorHelper.handleApiError(response);
                ErrorHelper.showError(error);
                return;
            }

            const resp = response.json();
            this.updateOne(resp.user)

            Swal.fire("User !", "Status successfully modified", "success");

        } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
        }
    },

    async  toManager(user_id) {
        try {
            Swal.showLoading(null);
            let body = { role: "manager", status: "active" };

            const route = "users/" + user_id + "/status/toggle";
            const response = await fetch(Helper.route(route), Helper.requestOptionsJSON("PUT", body))

            if (!response.ok) {
                const error = await ErrorHelper.handleApiError(response);
                ErrorHelper.showError(error);
                return;
            }

            const resp = response.json();
            this.updateOne(resp.user)

            Swal.fire("Agent !", "L'utilisateur est desormais un manager.", "success");

        } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
        }
    },


    
        async toAgent(user_id) {
            try {
                let body = {
                    status: "active",
                    user: {
                        id: user_id,
                    },
                };

                const route = "agents";
                const response = await fetch(Helper.route(route), Helper.requestOptionsJSON("POST", body))

                if (!response.ok) {
                    const error = await ErrorHelper.handleApiError(response);
                    ErrorHelper.showError(error);
                    return;
                }

                const resp = response.json();
                this.updateOne(resp.user)

                Swal.fire("Agent !", "L'utilisateur est desormais un manager.", "success");

            } catch (error) {
                    const normalizedError = ErrorHelper.handleUnexpectedError(error);
                    ErrorHelper.showError(normalizedError);
                    throw normalizedError;
            }
        },



        //// Specifical methods

        async  loadTransfersOf(id, loading=false) {
            try {
                if(loading){
                    Swal.showLoading(null);
                }
                

                const route = "transfers/of/users/" + id ;
                const response = await fetch(Helper.route(route), Helper.requestOptionsJSON())

                if (!response.ok) {
                    const error = await ErrorHelper.handleApiError(response);
                    ErrorHelper.showError(error);
                    return;
                }

                const resp = response.json();
                let user = this.getOneDetails(id) ?? this.getOne(id);
                if(!user){
                    if(resp.length >0){
                        user =  resp[0]?.idOfSender == id ? resp[0].sender : resp.receiver;
                    }else {
                        user = await this.loadOne(id);
                    }
                }
                user.transfers =  resp;
                this.updateOne(user);
                this.addDetail(user);
                this.info = user;

                if(loading){
                    Swal.fire("User !", "Status successfully modified", "success");
                }

                return resp;

            } catch (error) {
                    const normalizedError = ErrorHelper.handleUnexpectedError(error);
                    ErrorHelper.showError(normalizedError);
                    throw normalizedError;
            }
        },

        async  loadContactsOf(id, loading=false) {
            try {
                if(loading){
                    Swal.showLoading(null);
                }
                

                const route = "contacts/users/" + id ;
                const response = await fetch(Helper.route(route), Helper.requestOptionsJSON())

                if (!response.ok) {
                    const error = await ErrorHelper.handleApiError(response);
                    ErrorHelper.showError(error);
                    return;
                }

                const resp = response.json();
                let user = this.getOneDetails(id) ?? this.getOne(id);
                if(!user){
                    if(resp.length >0){
                        user =  resp[0]?.user;
                    }else {
                        user = await this.loadOne(id);
                    }
                }
                user.contacts =  resp;
                this.updateOne(user);
                this.addDetail(user);
                this.info = user;

                console.log(resp, user, this.info);

                if(loading){
                    Swal.fire("User !", "Status successfully modified", "success");
                }

                return resp;

            } catch (error) {
                    const normalizedError = ErrorHelper.handleUnexpectedError(error);
                    ErrorHelper.showError(normalizedError);
                    throw normalizedError;
            }
        },

         async  loadAccounts(id, loading=false) {
            try {
                if(loading){
                    Swal.showLoading(null);
                }
                

                const route = "accounts/users/" + id ;
                const response = await fetch(Helper.route(route), Helper.requestOptionsJSON())

                if (!response.ok) {
                    const error = await ErrorHelper.handleApiError(response);
                    ErrorHelper.showError(error);
                    return;
                }

                const resp = response.json();
                let user = this.getOneDetails(id) ?? this.getOne(id);
                if(!user){
                    if(resp.length >0){
                        user =  resp[0]?.idOfSender == id ? resp[0].sender : resp.receiver;
                    }else {
                        user = await this.loadOne(id);
                    }
                }
                user.contacts =  resp;
                this.updateOne(resp);
                this.addDetail(resp);
                this.info = user;

                if(loading){
                    Swal.fire("User !", "Status successfully modified", "success");
                }

            } catch (error) {
                    const normalizedError = ErrorHelper.handleUnexpectedError(error);
                    ErrorHelper.showError(normalizedError);
                    throw normalizedError;
            }
        },

       
    },
     persist: {
         storage: sessionStorage,
                 key: `${Helper.env}__users`
         
    },
})